<div [class.animate-pulse]="loading()">
    <div class="flex gap-2 w-full my-4">
        <div class="size-5 shrink-0 rounded-full bg-blue-500">
        </div>
        <div class="h-5 w-full rounded-full bg-button/90"></div>
    </div>
    <div class="grid grid-cols-3 gap-2 w-full pl-7 my-2">
        <div class="col-span-2 h-3 rounded-full bg-section"></div>
        <div class="col-span-1 h-3 rounded-full bg-section"></div>
        <div class="col-span-3 h-3 rounded-full bg-section"></div>
        <div class="col-span-1 h-3 rounded-full bg-section"></div>
        <div class="col-span-2 h-3 rounded-full bg-section"></div>
    </div>
    <!--buttons -->
    <div class="grid grid-cols-3 gap-2 w-full pl-7 my-4 max-w-sm">
        <div class="col-span-1 h-8 rounded-full bg-blue-500/20"></div>
        <div class="col-span-1 h-8 rounded-full bg-green-500/20"></div>
        <div class="col-span-1 h-8 rounded-full bg-red-500/20"></div>
    </div>
</div>
